import styled from 'styled-components';
import { EllipsisMiddle } from 'components/atoms/middle-ellipsis';
import { BodyShort01 } from 'components/styles';

export const GroupTitle = styled(EllipsisMiddle)`
  ${BodyShort01};
  color: var(--gray-80);
  width: calc(100% - var(--spacing-05));
`;
